"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MatchingOptionsOverlayControlModule = /** @class */ (function () {
    function MatchingOptionsOverlayControlModule() {
    }
    return MatchingOptionsOverlayControlModule;
}());
exports.MatchingOptionsOverlayControlModule = MatchingOptionsOverlayControlModule;
